export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-shopping-bag-bbbff40b8a6e991d004ad23c32e64dad.svg";